import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@env/environment";
import { Observable, catchError, map, of, timeout } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class BillingService {
  baseUrl = environment.BASE_PATH;
  constructor(private http: HttpClient) {}

  getExchangeRate(fromCurrency: string, toCurrency: string): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/billing/exchange-rate/${fromCurrency}/${toCurrency}`).pipe(
      timeout(10000),
      map(res => {
        return res.data;
      }),
      catchError(error => {
        throw error.error;
      })
    );
  }

  getExchangeRateV2(fromCurrency: string, toCurrency: string): Observable<number> {
    const cacheKey = `exchange-rate-${fromCurrency}-${toCurrency}`;
    const cached = localStorage.getItem(cacheKey);
  
    if (cached) {
      try {
        const parsed = JSON.parse(cached);
        const now = Date.now();
  
        if (parsed.expiry_timestamp && now < parsed.expiry_timestamp) {
          // Cache vẫn còn hạn
          return of(parsed.exchange_rate);
        } else {
          // Hết hạn → xóa cache
          localStorage.removeItem(cacheKey);
        }
      } catch (e) {
        // Không đọc được cache
        localStorage.removeItem(cacheKey);
      }
    }
  
    // Gọi API nếu không có cache hoặc cache hết hạn
    return this.http.get<any>(`${this.baseUrl}/billing/exchange-rate/v2/${fromCurrency}/${toCurrency}`).pipe(
      timeout(10000),
      map(res => {
        const data = res?.data;
        if (res?.success && data?.exchange_rate) {
          localStorage.setItem(
            cacheKey,
            JSON.stringify({
              exchange_rate: data.exchange_rate,
              expiry_timestamp: data.expiry_timestamp,
            })
          );
          return data.exchange_rate;
        } else {
          throw new Error('Failed to fetch exchange rate');
        }
      }),
      catchError(error => {
        console.error('Exchange rate API error:', error);
        throw error?.error || error;
      })
    );
  }
}